import React, { Component } from 'react'

import ContMessageI18N from '../../containers/ContMessageI18N';

const MSG_SEC_CONTEXT = 'testpage.section.context';
const MSG_SEC_VEH = 'testpage.section.vehicle';
const MSG_SEC_VEHS = 'testpage.section.vehicles';
const MSG_SEC_PARAMS = 'testpage.input.parameters';
const MSG_SEC_PX = 'testpage.section.partExchange';
const MSG_SEC_OPT = 'testpage.section.availableOptions';
const MSG_SEC_ACC = 'testpage.section.availableAccessories';

class TestJson extends Component {

	handleChangeJson = name => event => {
		try {
			if (event.target.value.length > 0) {
				var value = JSON.parse(event.target.value);
				this.applyOnChangeValue(name, value);
			} else if (name === 'parameters' || name === 'partExchange' || name === 'vehicle') {
				this.applyOnChangeValue(name, null);
			}
		} catch (e) { }
	};

	handleChangeParametersBase64 = () => event => {
		const checked = event.target.checked;
		if (this.props.parameters != null) {
			let newParams = this.props.parameters;
			if (checked) {
				if (!this.props.parameters.payloadBase64) {
					const newParamsPayloadBase64 = window.btoa(JSON.stringify({ ...this.props.parameters }));
					newParams = { payloadBase64: newParamsPayloadBase64 }
				}
			} else {
				const payloadBase64 = this.props.parameters.payloadBase64;
				if (payloadBase64 && payloadBase64.trim().length > 0) {
					newParams = JSON.parse(window.atob(payloadBase64));
				}
			}
			this.props.onChangeParameters(newParams);
		}
	};

	applyOnChangeValue(name, value) {
		switch (name) {
			case 'context':
				this.props.onChangeContext(value, this.props.settings.perimeterFilter, this.props.settings.vehDescType);
				break;
			case 'vehicle':
				this.props.onChangeVehicle(value);
				break;
			case 'availableOptions':
				this.props.onChangeAvailableOptions(value);
				break;
			case 'availableAccessories':
				this.props.onChangeAvailableAccessories(value);
				break;
			case 'vehiclesConfig':
				this.props.onChangeVehiclesConfig(value);
				break;
			case 'vehiclesDefault':
			case 'vehiclesStock':
				this.props.onChangeVehiclesStock(value);
				break;
			case 'partExchange':
				this.props.onChangePartExchange(value);
				break;
			case 'parameters':
				this.props.onChangeParameters(value);
				break;
			default:
				break;
		}
	}

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }

	render() {
		const paramsStr = this.props.parameters != null && Object.keys(this.props.parameters).length > 0 ? JSON.stringify(this.props.parameters) : '';
		const paramsBase64 = this.props.parameters != null && this.props.parameters.payloadBase64 != null;
		const partExchange = this.props.partExchange != null && Object.keys(this.props.partExchange).length > 0 ? JSON.stringify(this.props.partExchange) : '';
		let context;
		if (this.props.context != null && Object.keys(this.props.context).length > 0) {
			context = { ...context, componentCode: undefined };
			context = JSON.stringify(this.props.context);
		} else {
			context = '';
		}
		const vehicle = this.props.vehicle != null && Object.keys(this.props.vehicle).length > 0 ? JSON.stringify(this.props.vehicle) : '';
		const availableOptions = this.props.availableOptions != null && Object.keys(this.props.availableOptions).length > 0 ? JSON.stringify(this.props.availableOptions) : '';
		const availableAccessories = this.props.availableAccessories != null && Object.keys(this.props.availableAccessories).length > 0 ? JSON.stringify(this.props.availableAccessories) : '';
		const vehiclesConfig = this.props.vehiclesConfig != null && Object.keys(this.props.vehiclesConfig).length > 0 ? JSON.stringify(this.props.vehiclesConfig) : '';
		const vehiclesStock = this.props.vehiclesStock != null && Object.keys(this.props.vehiclesStock).length > 0 ? JSON.stringify(this.props.vehiclesStock) : '';

		return (
			<div className="container shadow p-2">
				<div className="row">
					<div className="col-12 col-md-6 col-lg-4 form-floating">
						{this.props.settings.isAutomationInput && <textarea id="jsonFieldContext" className="form-control" aria-label={this.getMessage(MSG_SEC_CONTEXT)}
							placeholder={this.getMessage(MSG_SEC_CONTEXT)}
							style={{ height: "350px" }} onChange={this.handleChangeJson('context')} defaultValue={context}>
						</textarea>}
						{!this.props.settings.isAutomationInput && <textarea id="jsonFieldContext" className="form-control" aria-label={this.getMessage(MSG_SEC_CONTEXT)}
							placeholder={this.getMessage(MSG_SEC_CONTEXT)}
							style={{ height: "350px" }} onChange={this.handleChangeJson('context')} value={context}>
						</textarea>}
						<label htmlFor='jsonFieldContext'>{this.getMessage(MSG_SEC_CONTEXT)}</label>
					</div>
					{this.props.settings.process !== 'vehiclesConfig' && this.props.settings.process !== 'vehiclesStock'
						&& this.props.settings.process !== 'vehiclesDefault'
						&& <div className="col-12 col-md-6 col-lg-4 form-floating">
							{this.props.settings.isAutomationInput &&
								<textarea id="jsonFieldVehicle" className="form-control" aria-label={this.getMessage(MSG_SEC_VEH)}
									placeholder={this.getMessage(MSG_SEC_VEH)}
									style={{ height: "350px" }} onChange={this.handleChangeJson('vehicle')} defaultValue={vehicle}>
								</textarea>}
							{!this.props.settings.isAutomationInput &&
								<textarea id="jsonFieldVehicle" className="form-control" aria-label={this.getMessage(MSG_SEC_VEH)}
									placeholder={this.getMessage(MSG_SEC_VEH)}
									style={{ height: "350px" }} onChange={this.handleChangeJson('vehicle')} value={vehicle}>
								</textarea>}
							<label htmlFor='jsonFieldVehicle'>{this.getMessage(MSG_SEC_VEH)}</label>
						</div>}
					{this.props.settings.process === 'options' &&
						<div className="col-12 col-md-6 col-lg-4 form-floating">
							<textarea id="jsonFieldAvailableOptions" className="form-control" aria-label={this.getMessage(MSG_SEC_OPT)}
								placeholder={this.getMessage(MSG_SEC_OPT)}
								style={{ height: "350px" }} onChange={this.handleChangeJson('availableOptions')} value={availableOptions}>
							</textarea>
							<label htmlFor='jsonFieldAvailableOptions'>{this.getMessage(MSG_SEC_OPT)}</label>
						</div>
					}
					{this.props.settings.process === 'accessories' &&
						<div className="col-12 col-md-6 col-lg-4 form-floating">
							<textarea id="jsonFieldAvailableAccessories" className="form-control" aria-label={this.getMessage(MSG_SEC_ACC)}
								placeholder={this.getMessage(MSG_SEC_ACC)}
								style={{ height: "350px" }} onChange={this.handleChangeJson('availableAccessories')} value={availableAccessories}>
							</textarea>
							<label htmlFor='jsonFieldAvailableAccessories'>{this.getMessage(MSG_SEC_ACC)}</label>
						</div>
					}
					{this.props.settings.process === 'vehiclesConfig' &&
						<div className="col-12 col-md-6 col-lg-4 form-floating">
							<textarea id="jsonFieldVehiclesConfig" className="form-control" aria-label={this.getMessage(MSG_SEC_VEHS)}
								placeholder={this.getMessage(MSG_SEC_VEHS)}
								style={{ height: "350px" }} onChange={this.handleChangeJson('vehiclesConfig')} value={vehiclesConfig}>
							</textarea>
							<label htmlFor='jsonFieldVehiclesConfig'>{this.getMessage(MSG_SEC_VEHS)}</label>
						</div>
					}
					{(this.props.settings.process === 'vehiclesStock' || this.props.settings.process === 'vehiclesDefault') &&
						<div className="col-12 col-md-6 col-lg-4 form-floating">
							<textarea id="jsonFieldVehiclesStock" className="form-control" aria-label={this.getMessage(MSG_SEC_VEHS)}
								placeholder={this.getMessage(MSG_SEC_VEHS)}
								style={{ height: "350px" }} onChange={this.handleChangeJson('vehiclesStock')} value={vehiclesStock}>
							</textarea>
							<label htmlFor='jsonFieldVehiclesStock'>{this.getMessage(MSG_SEC_VEHS)}</label>
						</div>
					}
					<div className="col-12 col-md-6 col-lg-4 form-floating">
						<textarea id="jsonFieldParameters" className="form-control" aria-label={this.getMessage(MSG_SEC_PARAMS)}
							placeholder={this.getMessage(MSG_SEC_PARAMS)}
							style={{ height: "350px" }} onChange={this.handleChangeJson('parameters')} value={paramsStr}>
						</textarea>
						<label htmlFor='jsonFieldParameters'>{this.getMessage(MSG_SEC_PARAMS)}</label>
						<div className="text-start w-100">
							<input className="form-check-input" type="checkbox" checked={paramsBase64}
								id="jsonFieldParametersBase64" onChange={this.handleChangeParametersBase64()} />
							<label className="form-check-label px-2" htmlFor="jsonFieldParametersBase64">
								{this.getMessage('generics.base64encoded')}
							</label>
						</div>
					</div>
					{this.props.settings.process !== 'vehiclesConfig' && this.props.settings.process !== 'vehiclesStock'
						&& this.props.settings.process !== 'vehiclesDefault' && this.props.settings.process !== 'options'
						&& this.props.settings.process !== 'accessories'
						&&
						<div className="col-12 col-md-6 col-lg-4 form-floating">
							<textarea id="jsonFieldPartExchange" className="form-control" aria-label={this.getMessage(MSG_SEC_PX)}
								placeholder={this.getMessage(MSG_SEC_PX)}
								style={{ height: "350px" }} onChange={this.handleChangeJson('partExchange')} value={partExchange}>
							</textarea>
							<label htmlFor='jsonFieldPartExchange'>{this.getMessage(MSG_SEC_PX)}</label>
						</div>
					}
				</div>
			</div>
		)
	}

}


export default (TestJson)

